"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../../helpers");

var _Chip = _interopRequireDefault(require("./Chip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Component = function Component(_ref) {
  var score = _ref.score,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["score", "children"]);

  return _react.default.createElement(_Chip.default, props, children, children ? ' ' : '', score, "%");
};

var ScoreChip = (0, _styledComponents.default)(Component).withConfig({
  displayName: "ScoreChip",
  componentId: "sc-3wkgvp-0"
})(["color:", ";background:", ";"], (0, _helpers.color)('white'), function (_ref2) {
  var score = _ref2.score;
  return (0, _helpers.scoreToBgColor)(score);
});
var _default = ScoreChip;
exports.default = _default;